<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <el-select v-model="platform_id" style="width:200px" class="handle-select mr10" @change="selectHandle">
                    <el-option
                      v-for="(child, index) in platforms"
                      :key="index"
                      :label="child.name" :value="child.id"></el-option>
                </el-select>
                <el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-add"
                    @click="handleEdit(null, true)"
                >新增</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                v-loading="loading"
            >
                <el-table-column label="序号" align="center" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.$index+1+page_index}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="platform_name" label="平台" align="center"></el-table-column>
                <el-table-column prop="app_name" label="应用名" align="center"></el-table-column>
                <el-table-column prop="app_key" label="app_key" align="center"></el-table-column>
                <el-table-column prop="app_secret" label="app_secret" align="center"></el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="handleVerifiesLook(scope.row)"
                        >验证类模板</el-button>
                        <el-button
                            type="text"
                            @click="handleNoticesLook(scope.row)"
                        >通知类模板</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.row, false)"
                        >修改</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="totalPages > 1">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="currentPage"
                    :page-size="page_size"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog :visible.sync="editVisible" width="50%" :close-on-click-modal="false">
            <el-form ref="ruleForm" :model="form" :rules="rules" label-width="120px">
                <el-form-item label="平台：" prop="sex" v-if="is_add">
                    <el-select v-model="form.platform_id" class="handle-select">
                        <el-option
                        v-for="(child, index) in window_platforms"
                        :key="index"
                        :label="child.name" :value="child.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="平台：" v-else>
                    <span class="fc">{{getPlatformType(form.platform_id)}}</span>
                </el-form-item>
                <el-form-item label="应用名：" prop="app_name">
                    <el-input v-model="form.app_name" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="app_key：" prop="app_key">
                    <el-input v-model="form.app_key" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="app_secret：" prop="app_secret">
                    <el-input v-model="form.app_secret" @input="onInput()"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="saveEdit('ruleForm')">提 交</el-button>
            </span>
        </el-dialog>

        <!-- 验证类模板列表 -->
        <el-dialog :visible.sync="verifiesLookVisible" width="80%" :close-on-click-modal="false">
            <div class="handle-box">
                <el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-add"
                    @click="handleVerifiesEdit(null, true)"
                >新增</el-button>
            </div>
            <el-table
                :data="verifiesTableData"
                border
                class="table"
                ref="windowMultipleTable"
                header-cell-class-name="table-header"
                v-loading="window_loading"
            >
                <el-table-column label="序号" align="center" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.$index+1+window_page_index}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="app_name" label="应用名" align="center"></el-table-column>
                <el-table-column prop="app_key" label="app_key" align="center"></el-table-column>
                <el-table-column prop="app_secret" label="app_secret" align="center"></el-table-column>
                <el-table-column prop="title" label="标题" align="center"></el-table-column>
                <el-table-column prop="code" label="code" align="center"></el-table-column>
                <el-table-column prop="sign_name" label="渠道" align="center"></el-table-column>
                <el-table-column prop="template_code" label="template_code" align="center"></el-table-column>
                <el-table-column prop="allow_count" label="允许次数" align="center"></el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleVerifiesEdit(scope.row, false)"
                        >修改</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleVerifiesDelete(scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="windowTotalPages > 1">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="windowCurrentPage"
                    :page-size="window_page_size"
                    :total="windowPageTotal"
                    @current-change="handleVerifiesPageChange"
                ></el-pagination>
            </div>
        </el-dialog>

        <!-- 验证类模板编辑弹出框 -->
        <el-dialog :visible.sync="verifiesEditVisible" width="50%" :close-on-click-modal="false">
            <el-form ref="verifiesRuleForm" :model="verifies_form" :rules="verifies_rules" label-width="130px">
                <el-form-item label="标题：" prop="title">
                    <el-input v-model="verifies_form.title" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="code：" prop="code">
                    <el-input v-model="verifies_form.code" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="渠道：" prop="sign_name">
                    <el-input v-model="verifies_form.sign_name" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="template_code：" prop="template_code">
                    <el-input v-model="verifies_form.template_code" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="允许次数：" prop="allow_count">
                    <el-input type="number" v-model="verifies_form.allow_count" @input="onInput()"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="saveVerifiesEdit('verifiesRuleForm')">提 交</el-button>
            </span>
        </el-dialog>

        <!-- 通知类模板列表 -->
        <el-dialog :visible.sync="noticesLookVisible" width="80%" :close-on-click-modal="false">
            <div class="handle-box">
                <el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-add"
                    @click="handleNoticesEdit(null, true)"
                >新增</el-button>
            </div>
            <el-table
                :data="noticesTableData"
                border
                class="table"
                ref="windowMultipleTable"
                header-cell-class-name="table-header"
                v-loading="window_loading"
            >
                <el-table-column label="序号" align="center" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.$index+1+window_page_index}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="app_name" label="应用名" align="center"></el-table-column>
                <el-table-column prop="app_key" label="app_key" align="center"></el-table-column>
                <el-table-column prop="app_secret" label="app_secret" align="center"></el-table-column>
                <el-table-column prop="title" label="标题" align="center"></el-table-column>
                <el-table-column prop="sign_name" label="渠道" align="center"></el-table-column>
                <el-table-column prop="template_code" label="template_code" align="center"></el-table-column>
                <el-table-column prop="content" label="内容" align="center"></el-table-column>
                <el-table-column prop="variable" label="参数" align="center"></el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="sendNoticesMessage(scope.row)"
                        >发送短信</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleNoticesEdit(scope.row, false)"
                        >修改</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleNoticesDelete(scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="windowTotalPages > 1">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="windowCurrentPage"
                    :page-size="window_page_size"
                    :total="windowPageTotal"
                    @current-change="handleNoticesPageChange"
                ></el-pagination>
            </div>
        </el-dialog>

        <!-- 通知类模板编辑弹出框 -->
        <el-dialog :visible.sync="noticesEditVisible" width="50%" :close-on-click-modal="false">
            <el-form ref="noticesRuleForm" :model="notices_form" :rules="notices_rules" label-width="130px">
                <el-form-item label="标题：" prop="title">
                    <el-input v-model="notices_form.title" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="渠道：" prop="sign_name">
                    <el-input v-model="notices_form.sign_name" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="template_code：" prop="template_code">
                    <el-input v-model="notices_form.template_code" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="内容：" prop="content">
                    <el-input
                     type="textarea"
                     :autosize="{ minRows: 2, maxRows: 8}"
                     placeholder='申请的模板通知内容，示例如下：${value}医生，您的患者${value2}尚未到达医院进行检查...'
                     v-model="notices_form.content" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="参数：" prop="variable">
                    <el-input
                     type="textarea"
                     :autosize="{ minRows: 2, maxRows: 4}"
                     placeholder='value,value2...'
                     v-model="notices_form.variable" @input="onInput()"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="saveNoticesEdit('noticesRuleForm')">提 交</el-button>
            </span>
        </el-dialog>

        <!-- 发送通知短信编辑弹出框 -->
        <el-dialog :visible.sync="sendEditVisible" width="50%" :close-on-click-modal="false">
            <el-form ref="sendRuleForm" :model="send_form" :rules="send_rules" label-width="130px">
                <el-form-item label="手机号：" prop="phone" :rules="[{ required: true, validator: checkPhone, trigger: 'blur' }]">
                    <el-input v-model="send_form.phone" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="模板替换参数：" prop="variable_value">
                    <el-input
                     type="textarea"
                     :autosize="{ minRows: 2, maxRows: 4}"
                     :placeholder='send_form.placeholder_variable'
                     v-model="send_form.variable_value" @input="onInput()"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="saveNoticesSend('sendRuleForm')">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {_} from 'vue-underscore';
import http from '../../../../api/smsApiConfig'
export default {
    name: 'Applist',
    data() {
        return {
            platforms: [{"id": "", "name": "全部", "platform": ""}],
            window_platforms: [],
            platform_id: '',
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            page_size: 10,
            pageTotal: 10,
            page_index: 10,
            keyword: '',
            loading: false,
            is_add: false,
            editVisible: false,
            form: {},
            rules: {
                app_name: [{ required: true, message: "请填写应用名", trigger: "blur" }],
                app_key: [{ required: true, message: "请填写app_key", trigger: "blur" }],
                app_secret: [{ required: true, message: "请填写app_secret", trigger: "blur" }]
            },
            select_app_id: '',
            windowCurrentPage: 1,
            windowTotalPages: 1,
            window_page_size: 10,
            windowPageTotal: 10,
            window_page_index: 10,
            diagnosis_keyword: '',
            window_loading: false,
            verifiesTableData: [],
            verifiesLookVisible: false,
            verifiesEditVisible: false,
            verifies_form: {},
            verifies_rules: {
                title: [{ required: true, message: "请填写title", trigger: "blur" }],
                code: [{ required: true, message: "请填写code", trigger: "blur" }],
                sign_name: [{ required: true, message: "请填写sign_name", trigger: "blur" }],
                template_code: [{ required: true, message: "请填写template_code", trigger: "blur" }],
                allow_count: [{ required: true, message: "请填写允许次数", trigger: "blur" }]
            },
            noticesTableData: [],
            noticesLookVisible: false,
            noticesEditVisible: false,
            notices_form: {},
            notices_rules: {
                title: [{ required: true, message: "请填写title", trigger: "blur" }],
                sign_name: [{ required: true, message: "请填写sign_name", trigger: "blur" }],
                template_code: [{ required: true, message: "请填写template_code", trigger: "blur" }],
                content: [{ required: true, message: "请填写content", trigger: "blur" }],
                variable: [{ required: true, message: "请填写variable", trigger: "blur" }]
            },
            sendEditVisible: false,
            send_form: {},
            send_rules: {
                variable_value: [{ required: true, message: "请填写模板替换参数", trigger: "blur" }]
            }
        }
    },
    created() {
        let that = this;
        http.get("/admin/platform").then(function(res) {
            that.window_platforms = res.data.data;
            that.platforms = that.platforms.concat(that.window_platforms);
        });
        this.getData();
    },
    methods: {
        checkPhone(rule, value, callback){
            var re = new RegExp(/^(1)+\d{10}$/);
            if (value.length == 0) {
                callback(new Error('手机号不能为空'));
            }else if(!re.test(value)){
                callback(new Error('请填写正确的手机号'));
            } else {
                callback();
            }
        },
        getPlatformType(id){
            let item = _.filter(this.platforms, function(selector){ return selector.id === id; })[0];
            if(item){
                return item['name'];
            }else{
                return '';
            }
        },
        onInput(){
            this.$forceUpdate();
        },
        getData() {
            let that = this;
            that.loading = true;
            let params = {
                page: that.currentPage,
                page_size: that.page_size
            }
            params["platform_id"] = that.platform_id;
            http.get("/admin/app",{params: params}).then(function(res) {
                that.page_index = (that.currentPage - 1) * that.page_size;
                that.tableData = res.data.data.apps;
                that.currentPage = res.data.data.current_page;
                that.totalPages = res.data.data.total_pages;
                that.pageTotal = that.totalPages * that.page_size;
                that.loading = false;
            });
        },
        getVerifiesData() {
            let that = this;
            that.window_loading = true;
            let params = {
                page: that.windowCurrentPage,
                page_size: that.window_page_size
            }
            params["app_id"] = that.select_app_id;
            http.get("/admin/verify",{params: params}).then(function(res) {
                that.window_page_index = (that.windowCurrentPage - 1) * that.window_page_size;
                that.verifiesTableData = res.data.data.verifies;
                that.windowCurrentPage = res.data.data.current_page;
                that.windowTotalPages = res.data.data.total_pages;
                that.windowPageTotal = that.windowTotalPages * that.window_page_size;
                that.window_loading = false;
            });
        },
        getNoticesData() {
            let that = this;
            that.window_loading = true;
            let params = {
                page: that.windowCurrentPage,
                page_size: that.window_page_size
            }
            params["app_id"] = that.select_app_id;
            http.get("/admin/notice",{params: params}).then(function(res) {
                that.window_page_index = (that.windowCurrentPage - 1) * that.window_page_size;
                that.noticesTableData = res.data.data.notices;
                that.windowCurrentPage = res.data.data.current_page;
                that.windowTotalPages = res.data.data.total_pages;
                that.windowPageTotal = that.windowTotalPages * that.window_page_size;
                that.window_loading = false;
            });
        },
        selectHandle(){
            this.currentPage = 1;
            this.getData();
        },
        handlePageChange(val) {
            this.currentPage = val;
            this.getData();
        },
        handleDelete(row) {
            let that = this;
            // 二次确认删除
            that.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                let params = {app_id: row.app_id}
                http.delete("/admin/app", {params: params}).then(function(res) {
                    if (res.data.status_code == 200) {
                        that.$message.success('删除成功');
                        that.getData();
                    }
                });
            })
            .catch(() => {});
        },
        handleEdit(row, add) {
            this.is_add = add;
            if(add){
                this.form = {
                    platform_id: 1,
                    app_name: '',
                    app_key: '',
                    app_secret: ''
                }
                if(this.platform_id == ''){
                    this.form['platform_id'] = 1;
                }else{
                    this.form['platform_id'] = this.platform_id;
                }
            }else{
                this.form = {
                    app_id: row.app_id,
                    platform_id: row.platform_id,
                    app_name: row.app_name,
                    app_key: row.app_key,
                    app_secret: row.app_secret
                }
            }
            this.editVisible = true;
        },
        saveEdit(formName){
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        platform_id: that.form.platform_id,
                        app_name: that.form.app_name,
                        app_key: that.form.app_key,
                        app_secret: that.form.app_secret
                    }
                    if(that.is_add){
                        http.post("/admin/app", params).then(function(res) {
                            if (res.data.status_code == 200) {
                                that.$message.success(`新增成功`);
                                that.getData();
                            }
                        });
                    }else{
                        params['app_id'] = that.form.app_id;
                        http.put("/admin/app", params).then(function(res) {
                            if (res.data.status_code == 200) {
                                that.$message.success(`修改成功`);
                                that.getData();
                            }
                        });
                    }
                    that.editVisible = false;
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleVerifiesLook(row){
            this.select_app_id = row.app_id;
            this.windowCurrentPage = 1;
            this.verifiesLookVisible = true;
            this.getVerifiesData();
        },
        handleVerifiesPageChange(val) {
            this.windowCurrentPage = val;
            this.getVerifiesData();
        },
        handleVerifiesDelete(row) {
            let that = this;
            // 二次确认删除
            that.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                let params = {verify_id: row.verify_id}
                http.delete("/admin/verify", {params: params}).then(function(res) {
                    if (res.data.status_code == 200) {
                        that.$message.success('删除成功');
                        that.getVerifiesData();
                    }
                });
            })
            .catch(() => {});
        },
        handleVerifiesEdit(row, add) {
            this.is_add = add;
            if(add){
                this.verifies_form = {
                    title: '',
                    code: '',
                    sign_name: '',
                    template_code: '',
                    allow_count: ''
                }
            }else{
                this.verifies_form = {
                    verify_id: row.verify_id,
                    title: row.title,
                    code: row.code,
                    sign_name: row.sign_name,
                    template_code: row.template_code,
                    allow_count: row.allow_count
                }
            }
            this.verifiesEditVisible = true;
        },
        saveVerifiesEdit(formName){
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        app_id: that.select_app_id,
                        title: that.verifies_form.title,
                        code: that.verifies_form.code,
                        sign_name: that.verifies_form.sign_name,
                        template_code: that.verifies_form.template_code,
                        allow_count: that.verifies_form.allow_count
                    }
                    if(that.is_add){
                        http.post("/admin/verify", params).then(function(res) {
                            if (res.data.status_code == 200) {
                                that.$message.success(`新增成功`);
                                that.getVerifiesData();
                            }
                        });
                    }else{
                        params['verify_id'] = that.verifies_form.verify_id;
                        http.put("/admin/verify", params).then(function(res) {
                            if (res.data.status_code == 200) {
                                that.$message.success(`修改成功`);
                                that.getVerifiesData();
                            }
                        });
                    }
                    that.verifiesEditVisible = false;
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleNoticesLook(row){
            this.select_app_id = row.app_id;
            this.windowCurrentPage = 1;
            this.noticesLookVisible = true;
            this.getNoticesData();
        },
        handleNoticesPageChange(val){
            this.windowCurrentPage = val;
            this.getNoticesData();
        },
        handleNoticesDelete(row) {
            let that = this;
            // 二次确认删除
            that.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                let params = {notice_id: row.notice_id}
                http.delete("/admin/notice", {params: params}).then(function(res) {
                    if (res.data.status_code == 200) {
                        that.$message.success('删除成功');
                        that.getNoticesData();
                    }
                });
            })
            .catch(() => {});
        },
        handleNoticesEdit(row, add) {
            this.is_add = add;
            if(add){
                this.notices_form = {
                    title: '',
                    sign_name: '',
                    template_code: '',
                    content: '',
                    variable: ''
                }
            }else{
                this.notices_form = {
                    notice_id: row.notice_id,
                    title: row.title,
                    sign_name: row.sign_name,
                    template_code: row.template_code,
                    content: row.content,
                    variable: row.variable
                }
            }
            this.noticesEditVisible = true;
        },
        saveNoticesEdit(formName){
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        app_id: that.select_app_id,
                        title: that.notices_form.title,
                        sign_name: that.notices_form.sign_name,
                        template_code: that.notices_form.template_code,
                        content: that.notices_form.content,
                        variable: that.notices_form.variable
                    }
                    if(that.is_add){
                        http.post("/admin/notice", params).then(function(res) {
                            if (res.data.status_code == 200) {
                                that.$message.success(`新增成功`);
                                that.getNoticesData();
                            }
                        });
                    }else{
                        params['notice_id'] = that.notices_form.notice_id;
                        http.put("/admin/notice", params).then(function(res) {
                            if (res.data.status_code == 200) {
                                that.$message.success(`修改成功`);
                                that.getNoticesData();
                            }
                        });
                    }
                    that.noticesEditVisible = false;
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        sendNoticesMessage(row){
            this.send_form = {
                notice_id: row.notice_id,
                phone: '',
                placeholder_variable: row.variable,
                variable_value: ''
            }
            this.sendEditVisible = true;
        },
        saveNoticesSend(formName){
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        notice_id: that.send_form.notice_id,
                        phone: that.send_form.phone,
                        variable_value: that.send_form.variable_value
                    }
                    http.post("/admin/send_notice", params).then(function(res) {
                        if (res.data.status_code == 200) {
                            that.$message.success(`发送成功`);
                            that.getNoticesData();
                        }
                    });
                    that.sendEditVisible = false;
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.self-dialog-footer{
    display: block;
    text-align: center;
}
</style>
